import { makeStyles } from '@mui/styles';
import { ApplicationMuiTheme } from '@tassat/payments-themes/dist/types/theme';

export const muiStyles = makeStyles((theme: ApplicationMuiTheme) => ({
    fullWidth: {
        width: '100%',
        alignSelf: 'center' as 'center'
    },
    flexColumn: {
        display: 'flex',
        flexFlow: 'column nowrap'
    },
    checkboxField: {
        '& label': {
            width: '35px',
            alignItems: 'flex-start',
            minHeight: '1rem'
        },
        '& span': {
            border: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter || '#CFCFCF'}`,
            borderRadius: '3px'
        },
        marginRight: '1.2rem'
    },
    submitButtonContainer: { marginTop: '2.5rem' },
    submitButton: { width: 'auto' as 'auto' },
    submitError: { alignSelf: 'center' },
    warningStyle: {
        fontSize: '12px',
        color: '#202020',
        width: '110px',
        marginTop: '-15px'
    }
}));